<ion-item class="compact" lines="none">
    <app-simple-select [inline]="inline" [autoOpen]="autoOpen"
                       [multiple]="multiple"
                       translationPrefix="select.sort.column"
                       [selectList]="selectColumnList"
                       [(selectedItems)]="sortData.sortItems"
                       (selectedItemsChange)="updateData()">
    </app-simple-select>

    <ion-item button *ngIf="showDirection" lines="none" slot="end" class="compact right" detail="false"
              (click)="direction()">
        <ion-label position="stacked"
                   class="compact">
            {{"select.sort.direction" | translate}}
        </ion-label>
        <ion-icon *ngIf="sortData.direction === '-'"
                  name="chevron-up-outline">
        </ion-icon>
        <ion-icon *ngIf="sortData.direction === '+'"
                  name="chevron-down-outline">
        </ion-icon>
    </ion-item>
</ion-item>
